module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "18",
      "height": "20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M-3-2h24v24H-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.594 0L6.28.281 5.563 1H0v2h1v14c0 1.645 1.355 3 3 3h11c1.645 0 2-1.355 2-3V3h1V1h-5.563L11.72.281 11.406 0H6.594zm.843 2h3.125l.72.719.312.281H15v14c0 .555.555 1 0 1H4c-.555 0-1-.445-1-1V3h3.406l.313-.281L7.437 2zM6 6v9h2V6H6zm4 0v9h2V6h-2z",
      "fill": "#FFF",
      "fill-rule": "nonzero"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-488a6e5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/icons/svg/trash-basket.vue
// module id = 411
// module chunks = 1